export type AnalyticsEventName =
  | 'game_loaded'
  | 'run_started'
  | 'run_ended'
  | 'restart'
  | 'personal_best'
  | 'graphics_auto_changed'
  | 'control_mode_changed'
  | 'pause'
  | 'milestone_reached'
  | 'replay_started'
  | 'replay_completed'

export interface AnalyticsEvent {
  readonly name: AnalyticsEventName
  readonly timestamp: number
  readonly properties?: Readonly<Record<string, unknown>>
}

export interface Analytics {
  event(name: AnalyticsEventName, properties?: Readonly<Record<string, unknown>>): void
}

/** Local bounded analytics sink. It intentionally performs no network requests. */
export class LocalAnalytics implements Analytics {
  private readonly events: AnalyticsEvent[] = []

  public event(name: AnalyticsEventName, properties?: Readonly<Record<string, unknown>>): void {
    const entry: AnalyticsEvent = properties === undefined
      ? { name, timestamp: performance.now() }
      : { name, timestamp: performance.now(), properties: { ...properties } }
    this.events.push(entry)
    if (this.events.length > 100) this.events.shift()
  }

  public snapshot(): readonly AnalyticsEvent[] {
    return this.events.map((event) => ({ ...event }))
  }
}
